<template>
    <div class="refund">
        <h3>提现管理</h3>
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">

            <el-form-item label="订单号">
                <el-input v-model="filter.needsId" placeholder="订单号"></el-input>
            </el-form-item>

            <el-form-item label="用户昵称">
                <el-input v-model="filter.userName" placeholder="用户昵称"></el-input>
            </el-form-item>

            <el-form-item label="提现状态">
                <el-select v-model="filter.status">
                    <el-option v-for="val,key in status" :key="key" :value="key" :label="val"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="search" size="mini">查询</el-button>
                </el-button-group>
            </el-form-item>

        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column prop="id" label="提现单号"></el-table-column>
            <el-table-column prop="quoteId" label="结算单号"></el-table-column>
            <el-table-column prop="needsId" label="订单编号"></el-table-column>
            <el-table-column prop="userName" label="用户昵称"></el-table-column>
            <el-table-column prop="amount" label="提现金额"></el-table-column>
            <el-table-column prop="amountReceive" label="打款金额"></el-table-column>
            <el-table-column prop="createTime" label="提现时间"></el-table-column>
            <el-table-column prop="launchTime" label="确认时间"></el-table-column>
            <el-table-column label="提现状态">
                <template slot-scope="scope">{{status[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column prop="auditNote" label="驳回原因"></el-table-column>
            <el-table-column label="操作" v-if="false">
                <template slot-scope="scope">
                    <el-button size="mini" :disabled="scope.row.status !== 1" @click="update(scope.row, 2)">确认</el-button>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination background layout="prev, pager, next" :page-size="20" @current-change="i=>pageNum=i" :page-count="pageNum" :total="total" ref="pagination">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import api from '../api'
const {
    withdraw
} = api

import moment from 'moment'

export default {
    name: "refund",
    data() {
        return {
            loading: true,

            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            filter: {
                needsId: '',
                status: '1',
                userName: '',
            },
            status: {
                '-2': '已驳回',
                '1': '待审核',
                '2': '已确认',
                '5': '打款成功',
                '6': '打款失败',
                '7': '全部',
            }
        };
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    methods: {
        async fetch() {
            this.loading = true;
            let {
                needsId,
                status,
                userName,
            } = this.filter
            let obj = {
                needsId,
                status,
                userName,
                pageNum: this.pageNum,
                limit: this.limit,
            }

            let res = await withdraw.list(obj);
            this.list = res.data.data;
            this.loading = false;
            this.total = res.data.pageinfo.totalCount
        },
        async update(item, status) {
            let res = await withdraw.update({
                id: item.id,
                status: status
            })

            let {
                code
            } = res.data
            if (code === 200) {
                this.$message.success('更新数据成功 ')
            }
            this.fetch()
        },
        async search() {
            this.$refs.pagination.internalCurrentPage = 1
            this.pageNum = 1
            this.fetch()
        }

    },
    mounted() {
        this.fetch();
    }
};
</script>
<style>
.user-list {}
</style>


// WEBPACK FOOTER //
// src/views/finance/withdraw.vue